import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Link = ({ color = '#8BD2D7', ...rest }: Props) => {
  return (
    <Svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.33337 11.3307H4.66671C3.74448 11.3307 2.95837 11.0057 2.30837 10.3557C1.65837 9.70573 1.33337 8.91962 1.33337 7.9974C1.33337 7.07517 1.65837 6.28906 2.30837 5.63906C2.95837 4.98906 3.74448 4.66406 4.66671 4.66406H7.33337V5.9974H4.66671C4.11115 5.9974 3.63893 6.19184 3.25004 6.58073C2.86115 6.96962 2.66671 7.44184 2.66671 7.9974C2.66671 8.55295 2.86115 9.02517 3.25004 9.41406C3.63893 9.80295 4.11115 9.9974 4.66671 9.9974H7.33337V11.3307ZM5.33337 8.66406V7.33073H10.6667V8.66406H5.33337ZM8.66671 11.3307V9.9974H11.3334C11.8889 9.9974 12.3612 9.80295 12.75 9.41406C13.1389 9.02517 13.3334 8.55295 13.3334 7.9974C13.3334 7.44184 13.1389 6.96962 12.75 6.58073C12.3612 6.19184 11.8889 5.9974 11.3334 5.9974H8.66671V4.66406H11.3334C12.2556 4.66406 13.0417 4.98906 13.6917 5.63906C14.3417 6.28906 14.6667 7.07517 14.6667 7.9974C14.6667 8.91962 14.3417 9.70573 13.6917 10.3557C13.0417 11.0057 12.2556 11.3307 11.3334 11.3307H8.66671Z"
        fill={color}
      />
    </Svg>
  )
}

export default Link
